class FMSiteNavigation extends HTMLElement {
  connectedCallback() {
    if (this.abortController) return;

    this.abortController = new AbortController();
    const { signal } = this.abortController;

    this.querySelectorAll('.fm-nav__group').forEach((group) => {
      group.addEventListener('toggle', () => {
        if (!group.open) return;
        this.querySelectorAll('.fm-nav__group[open]').forEach((other) => {
          if (other !== group) other.open = false;
        });
      }, { signal });
    });

    document.addEventListener('click', (event) => {
      if (!this.contains(event.target)) this.closeAll();
    }, { signal });

    this.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const openGroup = this.querySelector('.fm-nav__group[open]');
      if (!openGroup) return;
      openGroup.open = false;
      openGroup.querySelector('summary')?.focus();
    }, { signal });
  }

  disconnectedCallback() {
    this.abortController?.abort();
    this.abortController = null;
  }

  closeAll() {
    this.querySelectorAll('.fm-nav__group[open]').forEach((group) => {
      group.open = false;
    });
  }
}

if (!customElements.get('fm-site-navigation')) {
  customElements.define('fm-site-navigation', FMSiteNavigation);
}
